import { render, staticRenderFns } from "./PageMainProductTown.vue?vue&type=template&id=78ad8788&scoped=true&"
import script from "./PageMainProductTown.vue?vue&type=script&lang=js&"
export * from "./PageMainProductTown.vue?vue&type=script&lang=js&"
import style0 from "./PageMainProductTown.vue?vue&type=style&index=0&id=78ad8788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ad8788",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VCardSubtitle,VCardTitle,VContainer,VImg})
